import languages from './languages';

languages.init();

export const CHECKED_VAL = 'checked';

let dateValite = function (dateStr) {
  /* eslint-disbale no-control-regex */
  var dateReg = /[20|19]\d{2}[\-|\\]\d{2}[\-|\\]\d{2}/;
  if (!dateReg.test(dateStr)) {
    return false;
  }
  var res = false;
  try {
    /* eslint-disbale no-control-regex */
    var dates = dateStr.match(/(\d{4})\-(\d{2})\-(\d{2})/);
    var year = parseInt(dates[1]);
    var month = parseInt(dates[2]);
    var day = parseInt(dates[3]);
    var monthLen = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    if ((year % 4 == 0 && year % 100 !== 0) || year % 400 == 0) {
      monthLen[1] = 29;
    }
    var maxLength = monthLen[month - 1];
    res = day <= maxLength;
  } catch (err) {
    res = false;
  }
  return res;
};

let phoneValite = function (phone) {
  return /^\d{6,18}$/.test(phone);
};

let facebookValidate = function (facebookName) {
  return (
    facebookName == undefined ||
    (facebookName.length > 0 && facebookName.length <= 60)
  );
};

export let accountNameValidate = function (accountName) {
  var regExp = /^([a-zA-Z0-9]|[_\.@]){6,30}$/;
  return regExp.test(accountName);
};

export let pwdValidate = function (pwd) {
  var regExp = /^[\W|\w]{6,20}$/;
  return regExp.test(pwd);
};

let getValidateFaileRes = function (errmsg) {
  return {
    dirty: true,
    errmsg
  };
};

let idCardValidate = function (idCard) {
  return idCard && idCard.length > 0 && idCard.length <= 60;
};

let getValidateSuccessRes = function () {
  return {
    dirty: false,
    errmsg: ''
  };
};

let realNameValidate = function (_val) {
  var length = _val && _val.replace(/[^\x00-\xff]/g, '**').length;
  return length >= 4 && length <= 60;
};

export let emailValidate = function (email) {
  /* esline-disable  no-control-regex */
  let emailReg =
    /^[A-Za-z0-9\u4e00-\u9fa5\_\.\*\&\$\#\%-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
  return emailReg.test(email);
};

export let bindEmailValidate = function (params) {
  if (!emailValidate(params.email)) {
    return {
      dirty: true,
      errmsg: languages.get('emailVAlidateMsg')
    };
  }

  if (params.terms !== CHECKED_VAL) {
    return {
      dirty: true,
      errmsg: languages.get('checkServiceTips')
    };
  }

  if (!params.ckcode) {
    return {
      dirty: true,
      errmsg: languages.get('editVrfCodeTips')
    };
  }

  return {
    dirty: false,
    errmsg: ''
  };
};

export let upgradeValite = function ({
  terms,
  password,
  accountName,
  repassword
}) {
  if (terms !== CHECKED_VAL) {
    return {
      dirty: true,
      errmsg: languages.get('checkServiceTips')
    };
  }
  if (!accountNameValidate(accountName)) {
    return {
      dirty: true,
      errmsg: languages.get('accountValidateMsg')
    };
  }
  if (!pwdValidate(password)) {
    return {
      dirty: true,
      errmsg: languages.get('pwdValidateMsg')
    };
  }
  if (password !== repassword) {
    return {
      dirty: true,
      errmsg: languages.get('pwdRepeatTips')
    };
  }

  return {
    dirty: false,
    errmsg: ''
  };
};

export let profileValidate = function (usrInfo) {
  if (!realNameValidate(usrInfo.real_name) && undefined != usrInfo.real_name) {
    return {
      dirty: true,
      errmsg: languages.get('realNameValidateTips')
    };
  }

  if (!dateValite(usrInfo.birthday) && undefined != usrInfo.birthday) {
    return {
      dirty: true,
      errmsg: languages.get('brithdayValidateTips')
    };
  }

  if (!phoneValite(usrInfo.phone) && undefined != usrInfo.phone) {
    return {
      dirty: true,
      errmsg: languages.get('phoneValidateTips')
    };
  }

  if (usrInfo.terms !== CHECKED_VAL) {
    return {
      dirty: true,
      errmsg: languages.get('checkServiceTips')
    };
  }

  if (!facebookValidate(usrInfo.fb_account)) {
    return {
      dirty: true,
      errmsg: languages.get('facebookValidateTips')
    };
  }

  if (usrInfo.id_card_country == '0' && undefined != usrInfo.id_card_number) {
    return {
      dirty: true,
      errmsg: languages.get('areaSelectTips')
    };
  }

  if (
    !idCardValidate(usrInfo.id_card_number) &&
    undefined != usrInfo.id_card_number
  ) {
    return {
      dirty: true,
      errmsg: languages.get('iDCardValidataTips')
    };
  }

  return {
    dirty: false,
    errmsg: ''
  };
};

export let changePwdValite = function ({
  password,
  newPassword,
  reNewPwd,
  terms
}) {
  if (terms !== CHECKED_VAL) {
    return {
      dirty: true,
      errmsg: languages.get('checkServiceTips')
    };
  }
  if (!pwdValidate(password)) {
    return {
      dirty: true,
      errmsg: languages.get('pwdValidateMsg')
    };
  }
  if (!pwdValidate(newPassword)) {
    return {
      dirty: true,
      errmsg: languages.get('pwdValidateMsg')
    };
  }
  if (newPassword !== reNewPwd) {
    return {
      dirty: true,
      errmsg: languages.get('pwdRepeatTips')
    };
  }
  return {
    dirty: false,
    errmsg: ''
  };
};

export let safeQuessionValite = function (answers) {
  for (let i = 0, len = answers.length; i < len; i++) {
    if (answers[i].id == '') {
      return {
        dirty: true,
        errmsg: languages.get('slectQuessionTips')
      };
    }
    if (answers[i].answer == '') {
      return {
        dirty: true,
        errmsg: languages.get('answerTips')
      };
    }
  }
  return {
    dirty: false,
    errmsg: ''
  };
};

export let getVerrifyCodeValidate = function (email) {
  var validatePass = emailValidate(email);
  var res = validatePass
    ? getValidateSuccessRes()
    : getValidateFaileRes(languages.get('emailVAlidateMsg'));
  return res;
};

export let checkAccountValidate = function (params) {
  if (params.uname == '' || params.uname == undefined) {
    return {
      dirty: true,
      errmsg: languages.get('inputAccountName')
    };
  }
  if (params.ckcode == '' || params.ckcode == undefined) {
    return {
      dirty: true,
      errmsg: languages.get('editVrfCodeTips')
    };
  }
  if (params.isRecaptcha) {
    if (
      params.google_recaptcha_token == '' ||
      params.google_recaptcha_token == undefined
    ) {
      return {
        dirty: true,
        errmsg: languages.get('recaptchaTip')
      };
    }
  }
  return {
    dirty: false,
    errmsg: ''
  };
};

export let validateResetPwd = function (params) {
  if (params.password == '') {
    return {
      dirty: true,
      errmsg: languages.get('editPwdTips')
    };
  }

  if (params.repassword == '') {
    return {
      dirty: true,
      errmsg: languages.get('editRepeatPwdTips')
    };
  }

  if (params.repassword !== params.password) {
    return {
      dirty: true,
      errmsg: languages.get('pwdRepeatTips')
    };
  }

  if (!pwdValidate(params.password) || !pwdValidate(params.repassword)) {
    return {
      dirty: true,
      errmsg: languages.get('pwdValidateMsg')
    };
  }

  return {
    dirty: false,
    errmsg: ''
  };
};

export let validateMigrateCode = function ({ pw, repw }) {
  let regx = /\S{6,16}/;
  if (!regx.test(pw)) {
    return {
      dirty: true,
      errmsg: languages.get('account_16wzzj')
    };
  }
  if (pw !== repw) {
    return {
      dirty: true,
      errmsg: languages.get('accoun_lcsrdmmbyz')
    };
  }
  return {
    dirty: false,
    errmsg: ''
  };
};

export let validateSwitchMigrateCode = function ({ followCode, password }) {
  let regx = /\S{6,16}/;
  if (!followCode) {
    return {
      dirty: true,
      errmsg: languages.get('account_qsrzqdyjmhmm')
    };
  }
  if (!regx.test(password)) {
    return {
      dirty: true,
      errmsg: languages.get('account_16wzzj')
    };
  }
  return {
    dirty: false,
    errmsg: ''
  };
};

let vgmValidate = {
  nameReg: function (_val) {
    /* esline-disable  no-control-regex */
    var length = _val && _val.replace(/[^\x00-\xff]/g, '**').length;

    return length >= 1 && length <= 60;
  },
  facebookReg: function (_val) {
    return _val && _val.length > 0 && _val.length <= 60;
  },
  phoneReg: function (_val) {
    // return /^\d{6,18}$/.test(_val);
    /* esline-disable  no-control-regex */
    return /^\d{10}$/.test(_val); // 电话号码显示为十位。
  },
  idCardReg: function (_val) {
    /* esline-disable  no-control-regex */
    return _val && /(^\d{9}$)|(^\d{12}$)/gi.test(_val);
  },
  isEmail: function (_val) {
    /* esline-disable  no-control-regex */
    return (
      _val &&
      /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z])+$/.test(_val)
    );
  }
};

// 不校验证件号和发证日期的游戏ID
const SKIP_ID_CARD_VALIDATION_GAME_IDS = [221, 288, 349, 401, 201, 274, 301, 416];

export const validateVgmProfile = function (params, gameId) {
  const skipIdCardValidation = SKIP_ID_CARD_VALIDATION_GAME_IDS.includes(+gameId);
  for (var key in params) {
    switch (key) {
      case 'real_name':
        if (!params.real_name) {
          return {
            dirty: true,
            errmsg: 'Vui lòng điền thông tin liên quan về Tên&Họ'
          };
        }
        if (!vgmValidate.nameReg(params.real_name)) {
          return {
            dirty: true,
            errmsg: 'Tên & Họ(4-60 ký tự)'
          };
        }
        break;
      case 'birthday':
        if (!params.birthday) {
          return {
            dirty: true,
            errmsg: 'Vui lòng điền thông tin liên quan về Ngày sinh'
          };
        }
        // 未满18岁提示
        if (
          new Date().getFullYear() - new Date(params.birthday).getFullYear() <
          18
        ) {
          return {
            dirty: true,
            errmsg: 'Rất tiếc, trò chơi chỉ dành cho người từ 18 tuổi trở lên.'
          };
        }
        break;
      case 'id_card_issue_date':
        if (skipIdCardValidation) break;
        if (!params.id_card_issue_date) {
          return {
            dirty: true,
            errmsg: 'Vui lòng điền thông tin liên quan về Ngày cấp'
          };
        }
        break;
      case 'phone':
        if (!params.phone) {
          return {
            dirty: true,
            errmsg: 'Vui lòng điền thông tin liên quan về Số di động'
          };
        }
        if (!vgmValidate.phoneReg(params.phone)) {
          return {
            dirty: true,
            errmsg: 'Sai định dạng số điện thoại (10 số)'
          };
        }
        break;
      case 'verifyCode':
        if (!params.verifyCode) {
          return {
            dirty: true,
            errmsg: 'Hãy nhập mã xác minh'
          };
        }
        break;
      case 'terms':
        if (!params.terms) {
          return {
            dirty: true,
            errmsg: 'Hãy đọc và đồng ý điều khoản và chính sách phục vụ VGM'
          };
        }
        break;
      case 'id_card_number':
        if (skipIdCardValidation) break;
        if (!params.id_card_number) {
          return {
            dirty: true,
            errmsg: 'Sai định dạng CCCD/CMND (9 hoặc 12 số)'
          };
        }
        if (!vgmValidate.idCardReg(params.id_card_number)) {
          return {
            dirty: true,
            errmsg: 'Sai định dạng CCCD/CMND (9 hoặc 12 số)'
          };
        }
        break;
      case 'address':
        if (!params.address) {
          return {
            dirty: true,
            errmsg: 'Vui lòng điền thông tin liên quan về Địa Chỉ'
          };
        }
        break;
      case 'email':
        if (!vgmValidate.isEmail(params.email)) {
          return {
            dirty: true,
            errmsg: 'Lỗi quy cách email'
          };
        }
        break;
      default:
        break;
    }
  }
  return {
    dirty: false,
    errmsg: ''
  };
};

export const validatePhone = function (phone) {
  if (!phone) {
    return {
      dirty: true,
      errmsg: 'Vui lòng điền thông tin liên quan về Số di động'
    };
  }
  if (!vgmValidate.phoneReg(phone)) {
    return {
      dirty: true,
      errmsg: 'Sai định dạng số điện thoại (10 số)'
    };
  }
  return {
    dirty: false,
    errmsg: ''
  };
};
